import { renderInvitationContent } from "./invitationEmail";

// The same template as the e-mail the server sends (invitationEmail.ts is a copy of the server's file).
// Each recipient gets their own id in the address, so the preview shows its shape.
export const EmailPreview = ({ name, invitationText, lang }: { name: string; invitationText: string; lang: "en" | "no" }) => {
  const url = `${window.location.origin}/respond/?id=…`;
  const emailContent = renderInvitationContent({ lang, candidate: name, message: invitationText, url });

  return <div dangerouslySetInnerHTML={{ __html: emailContent }} />;
};
